import { Color } from "./types";

export const determineTextColor = (color: Color): string => {
  if (!color) return "";
  if (color === "white") return "text-gray-700";
  // Extracting the color category (e.g., 'primary') and the shade number (e.g., '300')
  const [colorCategory, shadeNumber] = color.match(/([a-zA-Z]+)(\d+)/)?.slice(1) ?? ["", ""];

  const shade = parseInt(shadeNumber, 10); // Convert shade number to an integer for comparison

  // Conditions for different color categories and their shade thresholds
  if (
    (colorCategory === "primary" && shade <= 300) ||
    (colorCategory === "neutral" && shade <= 500) ||
    (colorCategory === "red" && shade === 300)
  ) {
    return "text-gray-700"; // Tailwind class for #374151
  } else {
    return "text-white"; // Tailwind class for #FFFFFF
  }
};

export const mapValue = <T extends string, U extends string>(
  mapping: Record<T, U>,
  value: T,
): U | "" => mapping[value] || "";

export const emptyIfFalsy = (condition: any, retVal: string) => {
  return condition ? retVal : "";
};
